import React from "react";

const Home: React.FC = () => {
  return (
    <div>
      <h1>Senate Confirmations</h1>
      <p>Select a table from the navigation above.</p>
    </div>
  );
};

export default Home;
